document.addEventListener("DOMContentLoaded", () => {
  const basePriceMap = {
    "Rose Mist 2oz": 35,
    "4 Fills 8oz": 62,
    "Rose Mist Set 10oz": 82,
  };

  const measureRadios = document.querySelectorAll('input[name="option1"]');
  const packRadios = document.querySelectorAll('input[name="option2"]');
  const variantSelect = document.getElementById("ProductSelect");
  const subRadio = document.getElementById("purchaseTypeSubscription");
  const oneTimeRadio = document.getElementById("purchaseTypeOneTime");
  const oneTimeLabel = document.querySelector(".one-time-purchase-label");
  const subscriptionLabel = document.querySelector(".subscription-label");
  const oneTimePrice = document.querySelector("[data-rtx-onetime-price]");
  const subPrice = document.querySelector("[data-rtx-subscription-price]");
  const subscriptionBox = document.querySelector(
    "[data-retextion-subscription-box]",
  );

  function parsePriceEl(el) {
    if (!el) return 0;
    let txt = "";
    el.childNodes.forEach((n) => {
      if (n.nodeType === Node.TEXT_NODE) txt += n.textContent;
    });
    return parseFloat(txt.replace(/[^0-9.]/g, "")) || 0;
  }

  function parseVariantPrice(text) {
    const m = text.match(/\$([\d,]+(?:\.\d+)?)/);
    return m ? parseFloat(m[1].replace(/,/g, "")) : 0;
  }

  function ensureSibling(anchor, selector, tagName, className) {
    if (!anchor || !anchor.parentElement) return null;
    let el = anchor.parentElement.querySelector(selector);
    if (!el) {
      el = document.createElement(tagName);
      el.className = className;
      anchor.insertAdjacentElement("afterend", el);
    }
    return el;
  }

  function ensureOneTimeBadge() {
    if (!oneTimeLabel) return null;
    return ensureSibling(
      oneTimeLabel,
      ".mist-one-time-savings",
      "span",
      "mist-one-time-savings",
    );
  }

  function ensureSubscriptionBadge() {
    if (!subscriptionLabel) return null;
    return ensureSibling(
      subscriptionLabel,
      ".mist-subscription-savings",
      "span",
      "mist-subscription-savings",
    );
  }

  function setBadge(el, savings, originalCost) {
    if (!el) return;
    if (savings > 0 && originalCost > 0) {
      const pct = Math.ceil((savings / originalCost) * 100);
      el.textContent = `Save ${pct}%`;
    } else {
      el.textContent = "";
    }
  }

  function setCompareBelow(anchor, originalCost, savings) {
    const el = ensureSibling(
      anchor,
      ".mist-compare-below",
      "s",
      "mist-compare-below",
    );
    if (!el) return;
    if (savings > 0 && originalCost > 0) {
      el.textContent = `$${Math.round(originalCost)}`;
    } else {
      el.textContent = "";
    }
  }

  function setSubscriptionCompareBelow(originalCost, savings) {
    if (!subscriptionBox) return;
    let el = subscriptionBox.querySelector(":scope > .mist-compare-below");
    if (!el) {
      el = document.createElement("s");
      el.className = "mist-compare-below";
      subscriptionBox.appendChild(el);
    }
    if (savings > 0 && originalCost > 0) {
      el.textContent = `$${Math.round(originalCost)}`;
    } else {
      el.textContent = "";
    }
  }

  function updateSavings() {
    const selM = document.querySelector('input[name="option1"]:checked');
    const selQ = document.querySelector('input[name="option2"]:checked');
    const oneTimeBadge = ensureOneTimeBadge();
    const subscriptionBadge = ensureSubscriptionBadge();

    if (!selM || !selQ) {
      setBadge(oneTimeBadge, 0, 0);
      setBadge(subscriptionBadge, 0, 0);
      setCompareBelow(oneTimePrice, 0, 0);
      setSubscriptionCompareBelow(0, 0);
      return;
    }

    const measure = selM.getAttribute("data-option");
    const baseSingle = basePriceMap[measure] || 0;
    const packCount = parseInt(selQ.getAttribute("data-option"), 10) || 1;
    const originalCost = baseSingle * packCount;

    let oneTimeCurrent = parsePriceEl(oneTimePrice);
    if (!oneTimeCurrent && variantSelect) {
      const optText = variantSelect.options[variantSelect.selectedIndex].text;
      oneTimeCurrent = parseVariantPrice(optText);
    }
    const subCurrent = parsePriceEl(subPrice) || oneTimeCurrent;

    const oneTimeSavings = originalCost - oneTimeCurrent;
    const subSavings = originalCost - subCurrent;

    setBadge(oneTimeBadge, oneTimeSavings, originalCost);
    setBadge(subscriptionBadge, subSavings, originalCost);
    setCompareBelow(oneTimePrice, originalCost, oneTimeSavings);
    setSubscriptionCompareBelow(originalCost, subSavings);
  }

  function scheduleUpdate() {
    setTimeout(updateSavings, 0);
  }

  measureRadios.forEach((r) => r.addEventListener("change", scheduleUpdate));
  packRadios.forEach((r) => r.addEventListener("change", scheduleUpdate));
  if (variantSelect) variantSelect.addEventListener("change", scheduleUpdate);
  if (subRadio) subRadio.addEventListener("change", scheduleUpdate);
  if (oneTimeRadio) oneTimeRadio.addEventListener("change", scheduleUpdate);

  // rtx-pdp.js rewrites the subscription/one-time price innerHTML on its own
  // events (purchase type, frequency, variant). Re-run when those nodes change
  // so our compare-at sibling stays in sync.
  const observer = new MutationObserver(scheduleUpdate);
  [oneTimePrice, subPrice].forEach((node) => {
    if (node)
      observer.observe(node, {
        childList: true,
        characterData: true,
        subtree: true,
      });
  });

  const frequencyDropdown = document.querySelector(
    ".rtx-subscription-dropdown",
  );
  const originalSubscriptionLabelText = subscriptionLabel
    ? subscriptionLabel.textContent.trim()
    : "";

  function formatFrequencyTitle(optionText) {
    if (!optionText) return null;
    const text = optionText.trim();
    const numMatch = text.match(/(\d+)\s*(month|week|day)s?\b/i);
    if (numMatch) {
      const n = parseInt(numMatch[1], 10);
      const unit = numMatch[2].toLowerCase();
      if (n === 1) {
        return unit === "month"
          ? "Monthly Delivery"
          : unit === "week"
            ? "Weekly Delivery"
            : "Daily Delivery";
      }
      const capUnit = unit.charAt(0).toUpperCase() + unit.slice(1);
      return `${n}-${capUnit} Delivery`;
    }
    const wordMatch = text.match(/\b(monthly|weekly|daily)\b/i);
    if (wordMatch) {
      const w = wordMatch[1].toLowerCase();
      return w === "monthly"
        ? "Monthly Delivery"
        : w === "weekly"
          ? "Weekly Delivery"
          : "Daily Delivery";
    }
    return null;
  }

  function applyFrequencyTitle() {
    if (!subscriptionLabel || !frequencyDropdown) return;
    const opt =
      frequencyDropdown.selectedOptions && frequencyDropdown.selectedOptions[0];
    const text = opt ? opt.textContent : "";
    const newTitle = formatFrequencyTitle(text);
    subscriptionLabel.textContent = newTitle || originalSubscriptionLabelText;
  }

  if (frequencyDropdown) {
    frequencyDropdown.addEventListener("change", applyFrequencyTitle);
    new MutationObserver(applyFrequencyTitle).observe(frequencyDropdown, {
      childList: true,
    });
    applyFrequencyTitle();
  }

  const buyOnceTriggerLink = document.querySelector(".js-trigger-buy-once");
  const buyOnceLinkPrice = document.querySelector(".js-buy-once-link-price");
  const buyOnceLinkShipping = document.querySelector(
    ".js-buy-once-link-shipping",
  );
  const buyOnceLabel = document.querySelector(
    'label[for="purchaseTypeOneTime"]',
  );

  const shippingByMeasure = {
    "Rose Mist 2oz": "$4.95",
    "4 Fills 8oz": "$6.95",
    "Rose Mist Set 10oz": "$6.95",
  };

  function currentShippingPrice() {
    const sel = document.querySelector('input[name="option1"]:checked');
    const measure = sel ? sel.getAttribute("data-option") : null;
    return shippingByMeasure[measure] || "$6.95";
  }

  function ensureBoxShipping() {
    if (!buyOnceLabel) return null;
    const wrapper = buyOnceLabel.querySelector(".rtx-purchase-label__wrapper");
    if (!wrapper) return null;
    let el = wrapper.querySelector(".mist-buy-once-shipping");
    if (!el) {
      el = document.createElement("span");
      el.className = "mist-buy-once-shipping";
      el.style.cssText =
        "display: block; font-size: 12px; line-height: 1.3; margin-top: 3px; margin-left: 25px;";
      wrapper.appendChild(el);
    }
    return el;
  }

  function applyShipping() {
    const price = currentShippingPrice();
    if (buyOnceLinkShipping) buyOnceLinkShipping.textContent = price;
    const boxEl = ensureBoxShipping();
    if (boxEl) boxEl.textContent = `${price} Shipping`;
  }

  function showBuyOnce() {
    if (buyOnceLabel) buyOnceLabel.style.display = "";
    if (buyOnceTriggerLink) buyOnceTriggerLink.style.display = "none";
  }
  function hideBuyOnce() {
    if (buyOnceLabel) buyOnceLabel.style.display = "none";
    if (buyOnceTriggerLink) buyOnceTriggerLink.style.display = "block";
  }

  function syncBuyOnceLinkPrice() {
    if (!buyOnceLinkPrice || !oneTimePrice) return;
    const txt = oneTimePrice.textContent.trim();
    if (txt) buyOnceLinkPrice.textContent = txt;
  }

  if (buyOnceTriggerLink && buyOnceLabel) {
    if (subRadio && subRadio.checked) {
      hideBuyOnce();
    } else {
      showBuyOnce();
    }

    buyOnceTriggerLink.addEventListener("click", function (e) {
      e.preventDefault();
      showBuyOnce();
      if (oneTimeRadio) oneTimeRadio.click();
    });

    if (subRadio) {
      subRadio.addEventListener("change", function () {
        if (this.checked) hideBuyOnce();
      });
    }
    if (oneTimeRadio) {
      oneTimeRadio.addEventListener("change", function () {
        if (this.checked) showBuyOnce();
      });
    }

    syncBuyOnceLinkPrice();
    if (oneTimePrice) {
      new MutationObserver(syncBuyOnceLinkPrice).observe(oneTimePrice, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  applyShipping();
  measureRadios.forEach((r) => r.addEventListener("change", applyShipping));

  scheduleUpdate();

  // === Split subscription card into one card per frequency ===
  const purchaseOptionsEl = document.querySelector("purchase-options");
  let productData = null;
  if (purchaseOptionsEl) {
    try {
      productData = JSON.parse(purchaseOptionsEl.getAttribute("productData"));
    } catch (e) {
      productData = null;
    }
  }

  function getCurrentVariant() {
    if (!productData) return null;
    const selM = document.querySelector('input[name="option1"]:checked');
    const selQ = document.querySelector('input[name="option2"]:checked');
    const o1 = selM ? selM.getAttribute("data-option") : null;
    const o2 = selQ ? selQ.getAttribute("data-option") : null;
    return (
      productData.variants.find(
        (v) =>
          (o1 == null || v.option1 === o1) &&
          (o2 == null || v.option2 === o2),
      ) || productData.variants[0]
    );
  }

  function formatMoney(cents) {
    const { Shopify } = window;
    const currency = (Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    const locale = (Shopify && Shopify.locale) || "en";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(cents / 100);
  }

  function getSelectedPackCount() {
    const sel = document.querySelector('input[name="option2"]:checked');
    const v = sel ? parseInt(sel.getAttribute("data-option"), 10) : NaN;
    return Number.isFinite(v) && v > 0 ? v : 1;
  }

  function bottlesLabel(count) {
    return count === 1 ? "1 bottle" : `${count} bottles`;
  }

  function describePlan(text) {
    if (!text) return "";
    const t = text.trim();
    const packCount = getSelectedPackCount();
    const bottles = bottlesLabel(packCount);
    const m = t.match(/(\d+)\s*(month|week|day)s?\b/i);
    if (m) {
      const n = parseInt(m[1], 10);
      const unit = m[2].toLowerCase();
      if (n === 1) {
        const map = { month: "monthly", week: "weekly", day: "daily" };
        return `<strong>${bottles}</strong> delivered ${map[unit]}`;
      }
      return `<strong>${bottles}</strong> delivered every ${n} ${unit}s`;
    }
    const w = t.match(/\b(monthly|weekly|daily)\b/i);
    if (w)
      return `<strong>${bottles}</strong> delivered ${w[1].toLowerCase()}`;
    return "";
  }

  function refreshCardDescriptions() {
    if (!frequencyDropdown) return;
    document.querySelectorAll(".mist-frequency-card").forEach((card) => {
      const planId = card.getAttribute("data-plan-id");
      const opt = Array.from(frequencyDropdown.options).find(
        (o) => o.value === planId,
      );
      if (!opt) return;
      const descTextEl = card.querySelector(".mist-frequency-desc__text");
      if (descTextEl) descTextEl.innerHTML = describePlan(opt.textContent.trim());
    });
  }

  function buildFrequencyCards() {
    const widget = document.querySelector(".rtx-widget");
    if (!widget || !frequencyDropdown) return;
    const planOptions = Array.from(frequencyDropdown.options).filter(
      (o) => o.value !== "",
    );
    if (planOptions.length < 2) return;

    widget.querySelectorAll(".mist-frequency-card").forEach((n) => n.remove());

    planOptions.forEach((opt) => {
      const planId = opt.value;
      const optText = opt.textContent.trim();
      const title = formatFrequencyTitle(optText) || optText;
      const desc = describePlan(optText);
      const isMonthly = title === "Monthly Delivery";

      const card = document.createElement("label");
      card.className = "rtx-purchase-label mist-frequency-card";
      card.setAttribute("data-plan-id", planId);
      card.innerHTML =
        (isMonthly
          ? '<span class="mist-frequency-card__banner">Most Popular</span>'
          : "") +
        '<div class="rtx-purchase-label__wrapper">' +
        '<div class="rtx-purchase-label__inner">' +
        '<input type="radio" name="mistFrequencyChoice" tabindex="-1" aria-hidden="true">' +
        '<span class="subscription-label mist-frequency-title"></span>' +
        '<span class="mist-savings-label"></span>' +
        '<span class="mist-frequency-price"></span>' +
        '<div class="mist-frequency-desc">' +
        '<span class="mist-frequency-desc__text"></span>' +
        '<s class="mist-frequency-desc__compare"></s>' +
        "</div>" +
        '<div class="mist-frequency-free-shipping"><strong>Free Shipping</strong></div>' +
        "</div>" +
        "</div>";
      card.querySelector(".mist-frequency-title").textContent = title;
      card.querySelector(".mist-frequency-desc__text").innerHTML = desc;
      widget.appendChild(card);

      card.addEventListener("click", (e) => {
        e.preventDefault();
        selectFrequencyCard(planId);
      });
    });

    refreshCardPrices();
    syncSelectedCard();
    keepBannerAtBottom();
  }

  function keepBannerAtBottom() {
    const widget = document.querySelector(".rtx-widget");
    if (!widget) return;
    const banner = widget.querySelector(".js-subscription-management-note");
    if (!banner) return;
    banner.style.order = "";
    widget.appendChild(banner);
  }

  function refreshCardPrices() {
    const variant = getCurrentVariant();
    if (!variant) return;
    const FREE_SHIPPING_THRESHOLD_CENTS = 10000;
    const MOST_POPULAR_PACK_COUNT = 2;
    const showMostPopular = getSelectedPackCount() === MOST_POPULAR_PACK_COUNT;
    document.querySelectorAll(".mist-frequency-card").forEach((card) => {
      const planId = card.getAttribute("data-plan-id");
      const alloc = variant.selling_plan_allocations.find(
        (a) => String(a.selling_plan_id) === String(planId),
      );
      const priceEl = card.querySelector(".mist-frequency-price");
      const compareEl = card.querySelector(".mist-frequency-desc__compare");
      const savingsEl = card.querySelector(".mist-savings-label");
      const freeShipEl = card.querySelector(".mist-frequency-free-shipping");
      const bannerEl = card.querySelector(".mist-frequency-card__banner");
      card.classList.toggle("is-most-popular", !!bannerEl && showMostPopular);
      if (!priceEl) return;
      if (alloc) {
        const showCompare = alloc.price < variant.price;
        priceEl.innerHTML = `<span class="mist-frequency-price__current">${formatMoney(alloc.price)}</span>`;
        if (compareEl) {
          compareEl.textContent = showCompare ? formatMoney(variant.price) : "";
        }
        if (savingsEl) {
          if (showCompare && variant.price > 0) {
            const pct = Math.ceil(((variant.price - alloc.price) / variant.price) * 100);
            savingsEl.textContent = pct > 0 ? `Save ${pct}%` : "";
          } else {
            savingsEl.textContent = "";
          }
        }
        if (freeShipEl) {
          freeShipEl.classList.toggle("is-visible", alloc.price > FREE_SHIPPING_THRESHOLD_CENTS);
        }
      } else {
        priceEl.textContent = "";
        if (compareEl) compareEl.textContent = "";
        if (savingsEl) savingsEl.textContent = "";
        if (freeShipEl) freeShipEl.classList.remove("is-visible");
      }
    });
  }

  function selectFrequencyCard(planId) {
    if (subRadio && !subRadio.checked) {
      subRadio.click();
    }
    if (frequencyDropdown && frequencyDropdown.value !== planId) {
      frequencyDropdown.value = planId;
      frequencyDropdown.dispatchEvent(new Event("change", { bubbles: true }));
    }
    syncSelectedCard();
  }

  function syncSelectedCard() {
    const isSubscription = subRadio && subRadio.checked;
    const currentPlan = frequencyDropdown ? frequencyDropdown.value : "";
    document.querySelectorAll(".mist-frequency-card").forEach((card) => {
      const planId = card.getAttribute("data-plan-id");
      const radio = card.querySelector('input[type="radio"]');
      const selected = isSubscription && planId === currentPlan;
      card.classList.toggle("is-selected", selected);
      if (radio) radio.checked = selected;
    });
  }

  function tryBuildFrequencyCards() {
    if (!frequencyDropdown) return;
    const realOptions = Array.from(frequencyDropdown.options).filter(
      (o) => o.value !== "",
    );
    if (realOptions.length >= 2) buildFrequencyCards();
  }

  if (frequencyDropdown) {
    new MutationObserver(() => {
      tryBuildFrequencyCards();
      refreshCardPrices();
      syncSelectedCard();
    }).observe(frequencyDropdown, { childList: true });
    frequencyDropdown.addEventListener("change", syncSelectedCard);
  }
  const refreshCardsOnVariantChange = () =>
    setTimeout(() => {
      refreshCardPrices();
      refreshCardDescriptions();
    }, 0);
  measureRadios.forEach((r) =>
    r.addEventListener("change", refreshCardsOnVariantChange),
  );
  packRadios.forEach((r) =>
    r.addEventListener("change", refreshCardsOnVariantChange),
  );
  if (variantSelect)
    variantSelect.addEventListener("change", () =>
      setTimeout(refreshCardPrices, 0),
    );
  if (subRadio) subRadio.addEventListener("change", syncSelectedCard);
  if (oneTimeRadio) oneTimeRadio.addEventListener("change", syncSelectedCard);

  tryBuildFrequencyCards();
});
